import type * as React from 'react';

export function DocPage({
  kicker,
  title,
  lead,
  updated,
  children,
}: {
  kicker: string;
  title: string;
  lead: string;
  updated?: string;
  children: React.ReactNode;
}) {
  return (
    <article className="container py-16 sm:py-24">
      <header className="max-w-[62ch]">
        <p className="kicker">{kicker}</p>
        <h1 className="mt-4 text-[clamp(2.4rem,6vw,3.8rem)] leading-[1.02]">{title}</h1>
        <p className="mt-6 text-lg leading-relaxed text-foreground/80">{lead}</p>
        {updated ? <p className="kicker mt-6">Last updated {updated}</p> : null}
      </header>

      <div className="hairline my-12 max-w-[62ch]" />

      <div className="prose-bramble">{children}</div>
    </article>
  );
}
